import { ReactLenis } from "lenis/react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { TrustBand } from "@/components/TrustBand";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { About } from "@/components/About";
import { ProblemSolution } from "@/components/ProblemSolution";
import { Services } from "@/components/Services";
import { AccountManagement } from "@/components/AccountManagement";
import { Pricing } from "@/components/Pricing";
import { Metering } from "@/components/Metering";
import { WhoWeAssist } from "@/components/WhoWeAssist";
import { Municipalities } from "@/components/Municipalities";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { HowItWorks } from "@/components/HowItWorks";
import { StrongCTA } from "@/components/StrongCTA";
import { QuoteForm } from "@/components/QuoteForm";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingActions } from "@/components/FloatingActions";

export default function Landing() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App bg-background pb-16 lg:pb-0">
        <Header />
        <main>
          <Hero />
          <TrustBand />
          <EditorialMarquee />
          <About />
          <ProblemSolution />
          <Services />
          <AccountManagement />
          <Pricing />
          <Metering />
          <WhoWeAssist />
          <Municipalities />
          <WhyChooseUs />
          <HowItWorks />
          <StrongCTA />
          <QuoteForm />
          <Contact />
        </main>
        <Footer />
        <FloatingActions />
      </div>
    </ReactLenis>
  );
}
